import {setToken,getToken} from '@/tool/cookie'
import {createRoutes} from '@/tool/index'
import router from './router'
import { asyncRoutes } from '@/router'
import Qs from 'qs'
import storage from 'good-storage'

// 路由拦截器
let hasMenus = false // 是否有菜单数据
router.beforeEach((to, from, next) => {
	let token = getToken('token');
	if(token){// 判断是否有token
		if(to.path === '/login'){ // 登录中不能进入登录页面
			//  跳转到首页
			next({ path: '/' })
		}else if(hasMenus){ // 如果已经有菜单了
			next()
		}else{
			router.addRoutes(asyncRoutes)
			hasMenus = true
			next({ path: to.path || '/' })
			
		}
	}else{
		hasMenus = false // 如果重新登录，要重新获取菜单
		let to_path = ['/index','/login','/register','/forgot','/authorize_login'];
		if (to_path.includes(to.path)) {
		    next()
		} else {
		    // next('/login')
		    next('/index')
		}
	}
});